export default __webpack_public_path__ + "static/service5-c0044cf35f2111930d2fd9c30544912c.png";